<template>
<div class="p-p-5">
    <h2>{{ isAdmin ? `${company.companyname} - `: '' }}Ny ansatt</h2>
    <div class="p-fluid">
        <div class="p-field">
            <label for="name" class="mandatory">Navn</label>
            <InputText id="name" type="text" placeholder='Fornavn etternavn' v-model="newUser.name" />
        </div>
        <div class="p-field">
            <label for="Email" class="mandatory">E-post</label>
            <InputText id="Email" type="text" v-model='newUser.Email' placeholder='E-post addresse' />
        </div>
        <div class="p-field">
          <label for="password" class="mandatory">Passord</label>
          <Password 
            id="password" 
            v-model='newUser.password' 
            weakLabel="Minimum 6 tegn"
            mediumLabel="Godkjent passord"
            strongLabel="Godkjent passord"
            mediumRegex="[0-9a-zA-Z]{6,}" 
            strongRegex="[0-9a-zA-Z]{6,}" 
            toggleMask
            placeholder='Passord' 
          ></Password>
        </div>
        <div class="p-field">
            <label for="phone" class="mandatory">Telefonnummer</label>
            <InputText v-model="newUser.phone" id="phone" />
        </div>
    </div>
    <Message v-for="(error, index) in errors" :key="index" :closable="false" severity="error">{{ error }}</Message>
    <div class="p-mt-4 p-d-flex p-jc-end">
      <Button label="Lukk" @click="$router.go(-1)" class="p-button-text p-mr-2"/>
      <Button label="Lagre" @click="addEmployee()" />
    </div>
  </div>
</template>

<script>
import Message from 'primevue/message';
import Password from 'primevue/password';

export default {
name: 'employeeSearch',

components: {
  Message,
  Password
},

data(){
  return{
    
    errors: [],
    newUser: {
      Email: null,
      active: true,
      name: null,
      phone: null,
      receiveconfirmationemails: true, 
      worksatcompany: null,
      password: null
    }
  }
},


methods:{
  async addEmployee(){
    
    /* checks data before finishing the user for submition */
    
    
    this.errors = []
    
    if(this.newUser.Email == null)
      this.errors.push('Vennligst fyll ut Epostadresse')
    
    else if(!this.newUser.Email.includes('@') || !this.newUser.Email.includes('.'))
      this.errors.push('Ugyldig e-post')
    
    if(this.newUser.name == null || this.newUser.name > 3 || !this.newUser.name.includes(' '))
      this.errors.push('Venligst fyll ut fultnavn')
      
    if(this.newUser.password == null)
      this.errors.push('Venligst fyll ut passord (minimum 6 tegn)')
      
    if(this.newUser.phone == null || this.newUser.phone.length < 7)
      this.errors.push('Venligst fyll ut telefonnummer (minimum 8 siffer)')
      
    if(this.newUser.password != null && this.newUser.password.length < 6)
      this.errors.push('Passordet må være minimum 6 tegn langt')
    
    if(!this.errors.length){
      /* all checks are ok. Finishing off the user */  
      this.newUser.worksatcompany = [this.company.organizationnumber]
      this.$store.dispatch('employees/add', this.newUser)
      .then(response => {
        console.log('response', response)
        return response.json()
        
      })
      .then(response => {
        
        if(typeof response.message !== 'undefined'){
          console.log(response)
          this.errors.push(response.message)
        }
        else{
          this.$toast.add({
            severity:'success',
            summary: 'Ny ansatt',
            detail: `${this.newUser.name} er lagt til`,
            life: 5000,
          })
          this.$router.push({name: 'employees'})
        }
      })
      .catch(err => {
        console.log('err', err)
      })
    }
    
      
    
  },
},

computed:{
  company(){
    return this.$store.getters['companies/current']
  },
  isAdmin(){
    return this.$store.getters["user/isAdmin"]
  }
}
}
</script>